<!--
 * @Description  : 监控异常管理
 * @Author       : yefan
 * @Date         : 2025-11-11 14:26:25
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-12-19 15:16:51
 * @FilePath     : \ngs_platform_manage_admin\src\views\operation-management\camera-error-records\index.vue
-->
<template>
	<div class="h100 error-main">
		<filter-layout @search="search" @reset="reset" hasHeader :hasMore="activeTab == '1'">
			<template #header>
				<el-tabs v-model="activeTab" @tab-click="tabChange(activeTab)">
					<el-tab-pane name="1">
						<span slot="label">未完成</span>
					</el-tab-pane>
					<el-tab-pane name="2">
						<span slot="label">已完成</span>
					</el-tab-pane>
				</el-tabs>
			</template>
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="110px">
					<el-form-item label="招标项目名称">
						<el-input v-model="searchForm.tenderProjectName" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="标段名称">
						<el-input v-model="searchForm.lifeName" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="开评标室">
						<el-input v-model="searchForm.roomName" placeholder="请输入" clearable></el-input>
					</el-form-item>
					<el-form-item label="监控名称">
						<el-input v-model="searchForm.cameraName" placeholder="请输入" clearable></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #more v-if="activeTab == '1'">
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="90px">
					<el-form-item label="截取状态">
						<el-select v-model="searchForm.stateArr" placeholder="请选择" clearable multiple>
							<el-option :value="0" label="处理中"></el-option>
							<el-option :value="1" label="排队中"></el-option>
							<el-option :value="2" label="失败"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<div class="w-table-layout w-table-page pdt10">
					<div class="w-table-content">
						<el-table :data="filiterData" height="100%" highlight-current-row row-key="id" border ref="table" v-loading="tableLoading">
							<el-table-column type="index" label="序号" align="center" width="70"></el-table-column>
							<el-table-column
								prop="lifeName"
								label="标段名称"
								header-align="center"
								min-width="180"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="tenderProjectName"
								label="招标项目名称"
								header-align="center"
								min-width="180"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="roomName"
								label="开评标室"
								header-align="center"
								min-width="120"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="captureStartTime"
								label="截取开始时间"
								align="center"
								width="160"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="captureEndTime"
								label="截取结束时间"
								align="center"
								width="160"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column
								prop="cameraName"
								label="监控名称"
								header-align="center"
								min-width="120"
								show-overflow-tooltip
							></el-table-column>
							<el-table-column prop="state" label="截取状态" width="100" align="center" show-overflow-tooltip>
								<template slot-scope="scope">
									<el-tag size="small" type="waiting" v-if="scope.row.state == 0">处理中</el-tag>
									<el-tag size="small" type="success" v-if="scope.row.state == 1">排队中</el-tag>
									<el-tag size="small" type="primary" v-if="scope.row.state == 2">已完成</el-tag>
									<el-tag size="small" type="danger" v-if="scope.row.state == 9">失败</el-tag>
								</template>
							</el-table-column>
							<el-table-column align="left" width="180">
								<template slot="header">操作</template>
								<template slot-scope="scope">
									<template v-if="activeTab == 1">
										<el-button
											v-for="(item, index) in handleRowBtn(scope.row.state)"
											:key="'rowBtn' + index"
											size="small"
											round
											plain
											class="table-btn"
											:type="item.type"
											:disabled="item.disabled"
											@click="handleBtnClick(scope.row, item.eventName)"
										>
											<svg-icon :icon-class="item.iconClass"></svg-icon>
											{{ item.text }}
										</el-button>
									</template>

									<template v-if="activeTab == 2">
										<el-button
											type="success"
											size="small"
											round
											plain
											class="table-btn"
											@click="handleBtnClick(scope.row, 'download')"
										>
											<svg-icon icon-class="form-look"></svg-icon>
											下载
										</el-button>
										<el-button
											type="primary"
											size="small"
											round
											plain
											class="table-btn"
											@click="handleBtnClick(scope.row, 'play')"
										>
											<svg-icon icon-class="form-look"></svg-icon>
											查看视频
										</el-button>
									</template>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="w-table-footer">
						<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							:current-page="pageConfig.currentPage"
							:page-sizes="pageConfig.pageList"
							:page-size="pageConfig.pageSize"
							:total="pageConfig.total"
							layout="total, sizes, prev, pager, next, jumper"
						>
						</el-pagination>
					</div>
				</div>
			</template>

			<!-- 失败详情弹窗 -->
			<el-dialog
				:title="dialogObj.title"
				:visible.sync="dialogObj.visible"
				:width="dialogObj.width"
				:close-on-click-modal="false"
				@closed="handleClose"
				center
			>
				<div class="detail-box">
					<div class="detail-header">
						<el-row :gutter="10">
							<el-col :span="12">评标室：{{ currentRow.roomName }}</el-col>
							<el-col :span="12">开始时间：{{ currentRow.captureStartTime }}</el-col>
							<el-col :span="12">安装位置：{{ currentRow.location }}</el-col>
							<el-col :span="12">结束时间：{{ currentRow.captureEndTime }}</el-col>
						</el-row>
					</div>
					<div class="detail-list">
						<div class="list-header">历史截取失败原因</div>
						<div class="list-item" v-for="(item, index) in errorDetailList" :key="'error' + index">
							<div class="item-header">
								<span>{{ item.createDate }}</span>
								<span class="remark-text">{{ `第${index + 1}次失败原因` }}</span>
							</div>
							<div class="item-content">错误详情：{{ item.errorMsg }}</div>
						</div>
					</div>
				</div>
			</el-dialog>

			<!-- 视频播放弹窗 -->
			<el-dialog
				title="监控视频回放"
				:visible.sync="videoDialogVisible"
				width="1000px"
				:close-on-click-modal="false"
				@closed="videoClose"
				center
			>
				<div class="ezuikit-js">
					<div>
						<div id="video-container" style="height: 500px"></div>
					</div>
					<!-- <div>
						<button v-on:click="init">init</button>
						<button v-on:click="stop">stop</button>
						<button v-on:click="play">play</button>
						<button v-on:click="openSound">openSound</button>
						<button v-on:click="closeSound">closeSound</button>
						<button v-on:click="startSave">startSave</button>
						<button v-on:click="stopSave">stopSave</button>
						<button v-on:click="capturePicture">capturePicture</button>
						<button v-on:click="fullscreen">fullscreen</button>
						<button v-on:click="getOSDTime">getOSDTime</button>
						<button v-on:click="startTalk">startTalk</button>
						<button v-on:click="stopTalk">stopTalk</button>
						<button v-on:click="destroy">destroy</button>
					</div> -->
				</div>
			</el-dialog>

			<!-- 下载详情弹窗 -->
			<video-download ref="downloadDialog"></video-download>
		</filter-layout>
	</div>
</template>
<script>
import { EZUIKitPlayer } from 'ezuikit-js/ezuikit.js'
var player = null

import * as API from '@/api/modules/fieldManagement'

// components
import videoDownload from './dialog-download.vue'

export default {
	components: {
		videoDownload
	},
	data() {
		return {
			activeTab: '1',
			searchForm: {
				tenderProjectName: '',
				lifeName: '',
				roomName: '',
				cameraName: '',
				stateArr: [],
				state: ''
			},
			pageConfig: {
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0 // 当前总条数
			},
			filiterData: [],
			tableLoading: false,
			// 详情弹窗
			dialogObj: {
				visible: false,
				title: '失败详情',
				width: '800px'
			},
			currentRow: {},
			errorDetailList: [],
			// 视频查看
			videoDialogVisible: false,
			player: null,
			videoSrc: ''
		}
	},
	methods: {
		//查询
		search() {
			this.pageConfig.pageSize = 10
			this.pageConfig.currentPage = 1
			this.getData()
		},
		//重置
		reset() {
			this.searchForm = {
				tenderProjectName: '',
				lifeName: '',
				roomName: '',
				cameraName: '',
				stateArr: [],
				state: ''
			}
			this.pageConfig.pageSize = 10
			this.pageConfig.currentPage = 1
			this.getData()
		},
		tabChange(val) {
			this.activeTab = val
			this.searchForm = {
				tenderProjectName: '',
				lifeName: '',
				roomName: '',
				cameraName: '',
				stateArr: [],
				state: ''
			}
			this.search()
		},
		//获取列表数据
		getData() {
			let params = {
				current: this.pageConfig.currentPage,
				size: this.pageConfig.pageSize,
				type: this.activeTab,
				...this.searchForm
			}

			if (params.stateArr && params.stateArr.length > 0) {
				params.state = params.stateArr.join(',')
			}
			API.getErrorVideoPage(params)
				.then((res) => {
					this.filiterData = res.data.records
					this.pageConfig.total = parseInt(res.data.total)
				})
				.catch(() => {})
				.finally(() => {
					this.tableLoading = false
				})
		},
		// 切换显示条数
		handleSizeChange(val) {
			this.pageConfig.pageSize = val
			this.getData()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.pageConfig.currentPage = val
			this.getData()
		},
		// 操作按钮显示
		handleRowBtn(state) {
			let btnList = [
				{
					text: '重新截取',
					iconClass: 'form-refresh',
					disabled: false,
					type: 'warning',
					eventName: 'refresh'
				},
				{
					text: '详情',
					iconClass: 'form-look',
					disabled: false,
					type: 'primary',
					eventName: 'view'
				}
			]
			let arr = []
			switch (state) {
				// 失败
				case 9:
					arr = btnList
					break
				default:
					btnList[0].disabled = true
					arr = [btnList[0]]
			}
			return arr
		},
		// 操作按钮
		async handleBtnClick(row, type) {
			this.currentRow = this.$utils.clone(row, true)
			switch (type) {
				// 重新截取
				case 'refresh':
					this.$confirm('当前有视频截取任务进行中，将进入排队等候中！', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(async () => {
						this.tableLoading = true
						let time = 1000
						try {
							let res = await API.getVideoAgain({ id: row.id })
							if (res && res.code == 0) {
								setTimeout(() => {
									this.$message.success('截取成功！')
								}, 1000)
							}
							time = 2000
						} catch (err) {
							time = 1000
						} finally {
							setTimeout(() => {
								this.search()
							}, time)
						}
					})
					break
				// 查看详情
				case 'view':
					this.errorDetailList = []
					this.dialogObj.visible = true
					API.getErrorDetail({ id: row.id })
						.then((res) => {
							this.errorDetailList = res.data
						})
						.catch((err) => {
							this.errorDetailList = []
						})
					break
				// 下载
				case 'download':
					this.$refs.downloadDialog.dialogOpen(row)
					break
				// 查看视频
				case 'play':
					let playParams = {
						monitorId: row.id,
						tenantId: row.tenantId
					}
					API.getVideoPlay(playParams)
						.then((res) => {
							if (!!res.data.accessToken && !!res.data.url) {
								// url 拼接截取时间
								let startTime = this.$utils.toDateString(row.captureStartTime, 'yyyyMMddHHmmss')
								let endTime = this.$utils.toDateString(row.captureEndTime, 'yyyyMMddHHmmss')
								res.data.url = `${res.data.url}?begin=${startTime}&end=${endTime}`
								this.videoDialogVisible = true
								setTimeout(() => {
									this.init(res.data.accessToken, res.data.url)
								}, 1000)
							} else {
								this.$message.warning(res.data)
							}
						})
						.catch((err) => {})
					break
			}
		},
		// 弹窗关闭
		handleClose() {
			this.dialogObj.visible = false
		},

		// #region 视频相关
		videoClose() {
			this.destroy()
			this.videoDialogVisible = false
		},
		// 渲染
		init(accessToken, url) {
			if (player) {
				this.destroy()
			}

			player = new EZUIKitPlayer({
				id: 'video-container', // 视频容器ID
				accessToken,
				url,
				// simple: 极简版; pcLive: pc直播; pcRec: pc回放; mobileLive: 移动端直播; mobileRec: 移动端回放;security: 安防版; voice: 语音版;
				template: 'pcRec',
				height: 500,
				handleError: (error) => {
					console.error('handleError', error)
				},
				// quality: 6, //
				language: 'zh', // zh | en
				// staticPath: "./ezuikit_static", // 如果想使用本地静态资源，请复制根目录下ezuikit_static 到当前目录下， 然后设置该值
				decoderType: 'auto',
				scaleMode: 1, // 默认 0 完全填充窗口，会有拉伸 1: 等比适配 2: 等比完全填充窗口, 超出隐藏 @sine 8.2.0
				env: {
					// https://open.ys7.com/help/1772?h=domain
					// domain默认是 https://open.ys7.com, 如果是私有化部署或海外的环境，请配置对应的domain
					// The default domain is https://open.ys7.com If it is a private deployment or overseas (outside of China) environment, please configure the corresponding domain
					domain: 'https://open.ys7.com'
				},
				// staticPath:"https://openstatic.ys7.com/ezuikit_js/v8.1.9/ezuikit_static",
				// 日志打印设置
				// loggerOptions: {
				// 	// player.setLoggerOptions(options)
				// 	level: 'INFO', // INFO LOG  WARN  ERROR
				// 	name: 'ezuikit',
				// 	showTime: true
				// },
				// 视频流的信息回调类型
				/**
				 * 打开流信息回调，监听 streamInfoCB 事件
				 * 0 : 每次都回调
				 * 1 : 只回调一次
				 * 注意：会影响性能
				 * 默认值 1
				 */
				streamInfoCBType: 1
				// v8.1.10
				// 自定义清晰度 默认 null, 如果有值 sdk 内部不在进行获取, null 默认使用接口获取的清晰度列表, videoLevelList.length === 0 不展示清晰度控件 sdk 内部不在进行获取, videoLevelList.length > 0 展示控件 sdk 内部不在进行获取
				// videoLevelList: [
				//   { level: 1, name: "标清", streamTypeIn: 2 }, // 需要保证支持子码流 (streamTypeIn=2)
				//   { level: 2, name: "高清", streamTypeIn: 1 },
				// ],
				// videoLevelList: [
				//   { level: -1, name: "标清", streamTypeIn: 2 }, // 8.1.17 开始 当 level 的值小于 0时， 不在向设备发送指令，仅根据 streamTypeIn 切换码流 （请保证 streamTypeIn 对应的码流存在）
				//   { level: -2, name: "高清", streamTypeIn: 1 }, // 8.1.17 开始 当 level 的值小于 0时， 不在向设备发送指令，仅根据 streamTypeIn 切换码流 （请保证 streamTypeIn 对应的码流存在）
				// ]
			})

			console.warn('init player', player)

			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.videoInfo, (info) => {
			//   console.warn("eventEmitter videoInfo", info);
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.videoInfo, (info) => {
				console.warn('videoInfo', info)
			})

			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.audioInfo, (info) => {
			//   console.warn("eventEmitter audioInfo", info);
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.audioInfo, (info) => {
				console.warn('audioInfo', info)
			})

			// 首帧渲染成功
			// first frame display
			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.firstFrameDisplay, () => {
			//     console.warn("eventEmitter firstFrameDisplay ");
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.firstFrameDisplay, () => {
				console.warn('firstFrameDisplay ')
			})

			// 8.1.x 事件监听
			// player.eventEmitter.on(EZUIKitPlayer.EVENTS.streamInfoCB, (info) => {
			//   console.warn("eventEmitter streamInfoCB ", info);
			// });
			// 8.2.x 事件监听
			player.on(EZUIKitPlayer.EVENTS.streamInfoCB, (info) => {
				console.warn('streamInfoCB ', info)
			})

			window.player = player
		},
		play() {
			if (player)
				player.play().then((data) => {
					console.log('play 获取 数据', data)
				})
		},
		stop() {
			if (player)
				player.stop().then((data) => {
					console.log('stop 获取 数据', data)
				})
		},
		getOSDTime() {
			if (player)
				player.getOSDTime().then((data) => {
					console.log('getOSDTime 获取 数据', data)
				})
		},
		capturePicture() {
			if (player)
				player.capturePicture(`${new Date().getTime()}`).then((data) => {
					console.log('capturePicture 获取 数据', data)
				})
		},
		openSound() {
			if (player) player.openSound()
		},
		closeSound() {
			if (player) player.closeSound()
		},
		startSave() {
			if (player)
				player.startSave(`${new Date().getTime()}`).then((data) => {
					console.log('startSave 获取 数据', data)
				})
		},
		stopSave() {
			if (player)
				player.stopSave().then((data) => {
					console.log('promise 获取 数据', data)
				})
		},
		startTalk() {
			if (player) player.startTalk()
		},
		stopTalk() {
			if (player) player.stopTalk()
		},
		fullscreen() {
			if (player) player.fullscreen() // 8.2.0 新增, 老版本使用 fullScreen()
		},
		destroy() {
			if (player) {
				player.destroy().then((data) => {
					console.log('promise 获取 数据', data)
				})
				player = null
			}
		}
		// #endregion
	},
	created() {
		this.getData()
	},
	mounted() {
		// setTimeout(() => {
		// 	this.init()
		// }, 2000)
	},
	computed: {
		routeQuery() {
			return this.$route.query.type
		}
	}
}
</script>
<style lang="less" scoped>
.error-main {
	/deep/ .el-tabs__item {
		width: 100px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		background: #f0f0f0;
		border-radius: 3px 3px 0px 0px;
		color: #666;
		margin-right: 20px;
		padding: 0;
		.el-tabs__header {
			border-bottom: 1px solid #2671cc;
		}
	}
	/deep/ .el-tabs__item.is-active {
		color: #fff;
		background-color: #2671cc !important;
	}
	/deep/ .el-tabs__nav-wrap::after {
		background-color: #2671cc;
		height: 1px;
		z-index: 999;
	}
	/deep/ .el-tabs__active-bar {
		background-color: transparent;
	}
}

.detail-box {
	max-height: 600px;
	.detail-header {
		line-height: 32px;
	}

	.detail-list {
		padding: 20px 0;

		.list-header {
			border-top: 1px solid #eee;
			font-size: 24px;
			line-height: 50px;
			color: #000;
		}

		.list-item {
			padding: 10px;
			background-color: #f2f3f5;
			margin-bottom: 20px;
		}

		.item-header {
			display: flex;
			justify-content: space-between;
			align-content: center;
			line-height: 32px;
			font-size: 16px;
			color: #000;

			.remark-text {
				color: #ff6600;
			}
		}

		.item-content {
			font-size: 14px;
			line-height: 24px;
		}
	}
}
/deep/ .ezplayer-control-date {
	display: none;
}
</style>
